"use client";

import React from "react";

import { SVGIconComponent, SVGIconProps } from "./types";

const BrandRefinementIconContext = React.createContext(false);
export { BrandRefinementIconContext };

export function createBSRExperimentIcon(
  LegacyIcon: SVGIconComponent,
  BSRIcon: SVGIconComponent
): SVGIconComponent {
  const Component = React.memo(
    (props: SVGIconProps & React.RefAttributes<SVGElement>) => {
      const isEnabled = React.useContext(BrandRefinementIconContext);
      const IconToRender = isEnabled ? BSRIcon : LegacyIcon;
      return <IconToRender {...props} />;
    }
  );

  if (process.env.NODE_ENV !== "production") {
    Component.displayName = `BSRExperimentIcon(${LegacyIcon.displayName ?? "Legacy"})`;
  }

  return Component;
}
